import { createDispatchHook } from "react-redux";
import { StoreContext } from "../../../context/store.js";
const useAppDispatch = createDispatchHook(StoreContext).withTypes();
export {
  useAppDispatch
};
